import React, { Component } from "react";
import { formRefContext } from "./Form";

class LinkedFieldContainer extends Component {
  handleChildrenName(children) {
    // Handle null/undefined children
    if (!children) {
      return null;
    }

    // Handle array of children
    if (Array.isArray(children)) {
      return children.map((child) => this.handleChildrenName(child));
    }

    // Handle single React element
    const newChildren = React.cloneElement(children, {
      name: `${this.props?.displayId}_${children?.props?.name}`,
    });
    return newChildren;
  }

  computeGridClasses() {
    const { layout } = this.props;
    if (!layout || !layout.columns) return 'grid-cols-1';
    const { columns } = layout;
    return `grid-cols-${columns.default || 1} md:grid-cols-${columns.md || columns.default || 1} lg:grid-cols-${columns.lg || columns.md || columns.default || 1}`;
  }

  componentDidMount() {
    const { linkedFields, setLinkedFields } = this.context;
    let newLinkedFields = [...linkedFields];
    newLinkedFields.push({
      displayItem: this.props.displayId,
      defdossier: this.props.defdossierId,
    });
    setLinkedFields(newLinkedFields);
  }

  componentWillUnmount() {
    const { setLinkedFields } = this.context;
    setLinkedFields([]);
  }

  render() {
    const gridClasses = this.computeGridClasses();
    const gapClass = this.props.layout?.gap || 'gap-6';
    return (
      <div
        data-type="linked_field_container"
        className={this.props.className}
      >
        <div className={`grid ${gridClasses} ${gapClass}`}>
          {this.props?.children && this.props.children.length > 1
            ? this.props.children.map((children) => {
                return this.handleChildrenName(children);
              })
            : this.handleChildrenName(this.props.children)}
        </div>
      </div>
    );
  }
}

LinkedFieldContainer.contextType = formRefContext;

export default LinkedFieldContainer;
